const initialStateFR = {
  // PERSONAL INFORMATION
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  gender: '',

  // CURRENT RESIDENTIAL ADDRESS
  streetAddress: '',
  city: '',
  state: '',
  postCode: '',

  // CONTACT DETAILS
  emailAddress: '',
  phoneNo: '',

  // REPORTING REFERENCE NUMBER
  reportingReference: '',

  // OCR FILE NAMES
  fileNames: {
    file1: '',
    file2: '',
  },

  // ERROR HANDLING
  errors: {},
};

export default initialStateFR;
